import { lazy, Suspense } from 'react';
import { createFileRoute } from '@tanstack/react-router';
import { Loading } from '@/kit';

// Bajo demanda y al ARCHIVO, no al barrel, para que la pantalla viva en su propio chunk.
const ReconciliationPage = lazy(() =>
    import('@/domains/credit/reconciliation/ReconciliationPage').then((m) => ({
        default: m.ReconciliationPage,
    })),
);

// Ruta estática: gana sobre la dinámica hermana `$section`.
export const Route = createFileRoute('/_backoffice/credit/reconciliation')({
    component: CreditReconciliation,
});

function CreditReconciliation() {
    return (
        <Suspense fallback={<Loading fullScreen={false} className="py-16" />}>
            <ReconciliationPage />
        </Suspense>
    );
}
